import actions from '../../actionTypes';

export default group => {
  return {
    type: actions.ADDED_GROUP,
    group
  };
};



// WEBPACK FOOTER //
// ./src/reducers/groups/actions/addedGroup.js